module.exports = __webpack_public_path__ + "static/img/zhuapaijilu.c3083ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zhuapaijilu.png
// module id = uLTu
// module chunks = 24